import { render, staticRenderFns } from "./kpp-agpz.vue?vue&type=template&id=fddc54f8"
import script from "./kpp-agpz.vue?vue&type=script&lang=js"
export * from "./kpp-agpz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports